import { TrustLabelPeriod } from '../../../../../components-library/labels/TrustLabel';

export default {
  labels: {
    [TrustLabelPeriod.LESS_THAN_1_MONTH]: 'Over +100 kunder har allerede bestilt sikkert hos os',
    [TrustLabelPeriod.ONE_MONTH_OR_MORE]: 'Over +1.000 kunder har allerede bestilt sikkert hos os',
    [TrustLabelPeriod.SIX_MONTHS_OR_MORE]: 'Over +10.000 kunder har allerede bestilt sikkert hos os',
  },
};
